module.exports = __webpack_public_path__ + "static/media/root.b63c0518.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/root.jpeg
// module id = 306
// module chunks = 0